var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cf-container" },
    [
      _vm.showAvailableNodes
        ? _c(
            "div",
            { staticClass: "cf-available-nodes" },
            [
              _vm._l(_vm.nodesAvailableToAdd, function(node, index) {
                return [
                  node.isPopular
                    ? _c(
                        "button",
                        {
                          key: index,
                          staticClass: "cf-available-nodes__button",
                          on: {
                            click: function($event) {
                              return _vm.validateNode(node)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n        " + _vm._s(node.displayName) + "\n      "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              }),
              _vm._v(" "),
              _c(
                "Dropdown",
                { ref: "dropdown", attrs: { tag: "span", "menu-left": true } },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "cf-available-nodes__button cf-available-nodes__button--secondary"
                    },
                    [
                      _vm._v("\n        More "),
                      _c("i", {
                        staticClass: "fa fa-angle-down p-l-10",
                        attrs: { "aria-hidden": "true" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "dropdown" },
                    [
                      _vm._l(_vm.nodesAvailableToAdd, function(node, index) {
                        return [
                          !node.isPopular
                            ? _c(
                                "li",
                                {
                                  key: index,
                                  on: {
                                    click: function($event) {
                                      return _vm.validateNode(node)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(node.displayName) +
                                      "\n          "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                ],
                2
              ),
              _vm._v(" "),
              _vm.isValidatingNode
                ? _c("Loader", { attrs: { "custom-class": "size-sm" } })
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("CallFlowContainer", {
        ref: "callFlowContainer",
        attrs: { "available-nodes": _vm.availableNodesWithStyling },
        on: { drawNode: _vm.validateNode }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }